// mutations.js
export const setChangeRequests = (state, payload) => {
    const { data, op } = payload;

    if (op === "replace") {
        // data là mảng
        state.changeRequests = Array.isArray(data) ? data : [];
    }

    if (op === "modified") {
        if (!Array.isArray(state.changeRequests)) state.changeRequests = [];
        const index = state.changeRequests.findIndex(r => r._id === data._id);
        if (index !== -1) {
            state.changeRequests.splice(index, 1, data);
        } else {
            state.changeRequests.push(data);
        }
    }

    if (op === "add") {
        if (!Array.isArray(state.changeRequests)) state.changeRequests = [];
        state.changeRequests.push(data);
    }

    if (op === "remove") {
        if (!Array.isArray(state.changeRequests)) state.changeRequests = [];
        state.changeRequests = state.changeRequests.filter(r => r._id !== data._id);
    }
};